export const landingPlayNowButtonStyles = {
  playNowButton: {
    marginTop: "20px",
  },
};